import * as React from 'react';
import { getOffset, IScale } from "./TimelineScale";
import { ICanvasInnerComponentProps } from "./TimelineBody";
import { IBaseTimelineElement } from "./TimelineSegment";
import { SegmentCoordinates, TimelineBaseSegment } from "./TimelineBaseSegment";

export interface ITimelineActualDatesSegment extends IBaseTimelineElement {
    startDate: Date;
    finishDate: Date;
}

export const TimelineActualDatesSegment = (props: ICanvasInnerComponentProps<ITimelineActualDatesSegment>) => {
    const coordinates = React.useMemo(() => calculateCoordinates(props.scale, props.data, props.timelineWidth), [props.scale, props.data, props.timelineWidth]);
    return <TimelineBaseSegment coordinates={coordinates} data={props.data} className="actual-dates" />;
}

const calculateCoordinates = (scale: IScale, segment: ITimelineActualDatesSegment, timelineWidth: number): SegmentCoordinates => {
    const start = getOffset(scale, segment.startDate, timelineWidth);
    const end = getOffset(scale, segment.finishDate, timelineWidth);
    return {
        left: start.left,
        width: end.left - start.left,
        trimmedStart: start.isOutOfScale,
        trimmedEnd: end.isOutOfScale,
        isOutOfScale: start.isOutOfScale && end.isOutOfScale && start.left === end.left
    };
}